'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.1@dom-scroll-into-view/lib/index.js
// module id = 80
// module chunks = 0 1